const list = {
  path: 'list',
  component: resolve => require(['@/pages/admin/capital/list'], resolve),
  meta: {
    requireAuth: true
  }
}
export default list